/**
 * One status badge for the access pages (19 Oct, UI review finding 3): its
 * colour comes from the one status map (`STATUS_MEANING` in `lib/access`),
 * so "Waiting for approval" looks the same on the case, its items, the
 * approvals and the queues. Words only: names, dates and reasons go on the
 * line below, never in the badge.
 */

import { Badge } from "@norican/react";
import type { ReactNode } from "react";

import { type StatusDomain, statusMeaning, statusTone } from "../lib/access";

export interface StatusBadgeProps {
  domain: StatusDomain;
  status: string | null | undefined;
  children: ReactNode;
  size?: "xs" | "sm";
}

export function StatusBadge({ domain, status, children, size = "xs" }: StatusBadgeProps) {
  const meaning = statusMeaning(domain, status);
  return (
    <Badge
      tone={statusTone(domain, status)}
      variant={meaning === "action" ? "solid" : "subtle"}
      size={size}
    >
      {children}
    </Badge>
  );
}
